<div id="printClientLoyaltyPointsInfo">
  <div class="modal-header">
    <h5 class="modal-title text-capitalize" id="exampleModalLabel">
      <i class="fas fa-info-circle"></i> &nbsp; {{'ClientLoyaltyPointsInfo' | translate}}
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-12" *ngIf="ClientLoyaltyPoint ">
        <div class="text-start py-4">

          <div class="row">
            <div class="col-lg-12">
              <div class="formCard">
                <table class="table table-sm">

                  <tr>
                    <td>{{ 'ClientName' | translate }}</td>
                    <td>
                      {{ ClientLoyaltyPoint.ClientName}}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ 'ClientMobile' | translate }}</td>
                    <td>
                      {{ ClientLoyaltyPoint.ClientMobile}}
                    </td>
                  </tr>

                  <tr>
                    <td>{{ 'TotalNumberOfLoyaltyPoints' | translate }}</td>
                    <td>
                      {{ ClientLoyaltyPoint.TotalLoyaltyPoints }} &nbsp; {{ 'Point' | translate }}
                    </td>
                  </tr>

                  <tr>
                    <td>{{ 'TotalLoyaltyPointsAmount' | translate }}</td>
                    <td>
                      {{ ClientLoyaltyPoint.TotalLoyaltyPointsAmount.
                      toFixed(sharedService.GetFractionRoundCount) }}
                      &nbsp;
                      {{sharedService.Lang== 'ar' ? sharedService.CurrencyNameAr :
                      sharedService.CurrencyNameEn}}
                    </td>
                  </tr>

                  <tr>
                    <td>{{ 'LastUpdateDate' | translate }}</td>
                    <td> {{ ClientLoyaltyPoint.LastUpdateDate | date: 'dd/MM/yyyy hh:mm a'}}</td>
                  </tr>

                </table>


              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="col-lg-12" *ngIf="!ClientLoyaltyPoint">
        <div class="col-md-12 text-center py-4 my-4">
          <i class="fas fa-circle-notch fa-spin fa-3x"></i>
          <h1>{{'Loading' | translate}} </h1>
        </div>
      </div>
      <div class="col-lg-12">

        <div class="formCard">

          <br>
          <h5 class="text-capitalize" id="exampleModalLabel">
            <i class="fas fa-list px-2"></i> {{'ClientLoyaltyPointDetails' | translate}}
          </h5>
          <br>
          <div class="row">

            <div class="col-lg-12" *ngIf="(!LoadingGetClientLoyaltyPointExpirations &&
              ClientLoyaltyPointExpirations); let ClientLoyaltyPointExpirations; else loading">
              <div class="table-card">
                <table class="table table-stripedd table-sm table-bordered">
                  <thead class="table-head">
                    <tr style="color: black; font-size: large;">


                      <th style="width: 5%;" class="formatTd text-center">{{ 'Index' | translate }}</th>
                      <th style="width: 15%;" class="formatTd text-center">{{ 'NumberOfLoyaltyPoints' | translate }}
                      </th>
                      <th style="width: 15%;" class="formatTd text-center">{{ 'LoyaltyPointsAmount' | translate }}</th>
                      <th style="width: 15%;" class="formatTd text-center">{{ 'ExpirationDate' | translate }} </th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr *ngFor="let clientLoyaltyPointExpiration of ClientLoyaltyPointExpirations; let i=index">
                      <td class="formatTd text-center">
                        {{ i+1 }}
                      </td>
                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointExpiration.LoyaltyPoints}} &nbsp; {{ 'Point' | translate }}
                      </td>

                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointExpiration.LoyaltyPointsAmount.
                        toFixed(sharedService.GetFractionRoundCount)}} &nbsp;
                        {{sharedService.Lang== 'ar' ? sharedService.CurrencyNameAr :
                        sharedService.CurrencyNameEn}}
                      </td>

                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointExpiration.ExpirationDate ?
                        (clientLoyaltyPointExpiration.ExpirationDate | date: 'yyyy-MM-dd') : ('NoExpirationDate' |
                        translate)
                        }}
                      </td>

                    </tr>

                  </tbody>
                </table>
                <div class="text-center py-4 my-4" *ngIf="ClientLoyaltyPointExpirations.length == 0">
                  <h4 class="py-4">{{'NoDataFound' | translate}}</h4>
                </div>
              </div>

            </div>

            <div class="col-lg-12">
              <ng-template #loading>
                <div class="col-lg-12">
                  <app-loading></app-loading>
                </div>
              </ng-template>
            </div>

          </div>



        </div>

      </div>

      <div class="col-lg-12">

        <div class="formCard">

          <br>
          <h5 class="text-capitalize" id="exampleModalLabel">
            <i class="fas fa-list px-2"></i> {{'ClientLoyaltyPointLogs' | translate}}
          </h5>
          <br>
          <div class="row">


            <div class="col-lg-12"
              *ngIf="(!LoadingGetClientLoyaltyPointLogs && ClientLoyaltyPointLogs ); let ClientLoyaltyPointLogs ; else loading">
              <div class="table-card">
                <table class="table table-stripedd table-sm table-bordered">
                  <thead class="table-head">
                    <tr style="color: black; font-size: large;">
                      <th style="width: 13%;" class="formatTd text-center">{{ 'NumberOfLoyaltyPoints' | translate }}
                      </th>
                      <th style="width: 13%;" class="formatTd text-center">{{ 'LoyaltyPointsAmount' | translate }}</th>
                      <th style="width: 17%;" class="formatTd text-center">{{ 'TheBranchName' | translate }} </th>
                      <th style="width: 16%;" class="formatTd text-center">{{ 'TransactionDate' | translate }} </th>
                      <th style="width: 10%;" class="formatTd text-center">{{ 'BillCodeText' | translate }} </th>
                      <th style="width: 13%;" class="formatTd text-center">{{ 'LoyaltyPointsDirection' | translate }}
                      </th>
                      <th style="width: 18%;" class="formatTd text-center">{{ 'ExpirationDate' | translate }} </th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr
                      [ngClass]="clientLoyaltyPointLog.Direction ==
                      loyalityPointsDirection.Earned ? 'greenColor formatTd  text-center' : 'redColor formatTd  text-center'"
                      *ngFor="let clientLoyaltyPointLog of ClientLoyaltyPointLogs; let i=index">

                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointLog.LoyaltyPoints}} &nbsp; {{ 'Point' | translate }}
                      </td>
                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointLog.LoyaltyPointsAmount.
                        toFixed(sharedService.GetFractionRoundCount)}} &nbsp;
                        {{sharedService.Lang== 'ar' ? sharedService.CurrencyNameAr :
                        sharedService.CurrencyNameEn}}
                      </td>
                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointLog.BranchName ?? ('NotFound' | translate)}}
                      </td>
                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointLog.Date | date: 'yyyy-MM-dd hh:mm a'}}
                      </td>
                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointLog.BillCode ?? ('NotFound' | translate)}}
                      </td>

                      <td class="formatTd" *ngIf="clientLoyaltyPointLog.Direction ==
                          loyalityPointsDirection.Earned">{{
                        ('Earned'| translate) }}</td>
                      <td class="formatTd" *ngIf="clientLoyaltyPointLog.Direction ==
                          loyalityPointsDirection.Redeemed">{{
                        ('Redeemed' |translate)}}</td>

                      <td class="formatTd text-center">
                        {{ clientLoyaltyPointLog.ExpirationDate ?
                        (clientLoyaltyPointLog.ExpirationDate | date: 'yyyy-MM-dd') : ('NoExpirationDate' | translate)
                        }}
                      </td>

                    </tr>

                  </tbody>
                </table>
                <div class="text-center py-4 my-4" *ngIf="ClientLoyaltyPointLogs.length == 0">
                  <h4 class="py-4">{{'NoDataFound' | translate}}</h4>
                </div>
              </div>

            </div>

            <div class="col-lg-12" [hidden]="!ClientLoyaltyPointLogs">
              <app-pagination (GetSources)="GetClientLoyaltyPointLogs()" #pagerClientLoyaltyPointLogs></app-pagination>
            </div>

            <div class="col-lg-12">
              <ng-template #loading>
                <div class="col-lg-12">
                  <app-loading></app-loading>
                </div>
              </ng-template>
            </div>

          </div>



        </div>

      </div>
    </div>


  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="activeModal.close('Close click')">
      {{'Close' | translate}}</button>

    <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="printPage()">{{'Print' |
      translate}}</button>
  </div>
</div>
